export default __webpack_public_path__ + "static/media/chair_alt.b1b7e127.svg";